<template>
  <div class="main-app">
    <Swiper :swiperImgs="bannerImgs" />
    <div class="info-section">
      <div class="container-fluid">
        <el-row :gutter="20" class="index-news-wrap">
          <el-col :span="12" :xs="24" class="news-item">
            <Swiper :swiperImgs="itemImgsA" :refNode="'swiperA'" />
          </el-col>
          <el-col :span="12" :xs="24" class="news-item">
            <Swiper :swiperImgs="itemImgsB" :refNode="'swiperB'" />
          </el-col>
          <el-col :span="12" :xs="24" class="news-item">
            <Swiper :swiperImgs="itemImgsC" :refNode="'swiperC'" />
          </el-col>
          <el-col :span="12" :xs="24" class="news-item">
            <Swiper :swiperImgs="itemImgsD" :refNode="'swiperD'" />
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="container">
      <div class="type-section">
        <div class="type-head">
          <div class="head-img">
            {{ $t("indextitle") }}
            <!-- <img src="~@a/img/index-type.png" alt="" /> -->
          </div>
        </div>
        <el-row class="type-row" :gutter="20">
          <el-col
            :span="6"
            :xs="12"
            v-for="(v, index) in typeData"
            :key="index"
          >
            <div class="type-box">
              <div class="type-icon" :class="v.icon">
                <img :src="v.img" alt="" />
              </div>
              <div class="type-text">{{ v.text }}</div>
              <div class="type-tips">{{ v.tips }}</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import LStore from "store";
import API from "@/api";
import { timeFormatDate, timeFormatYear, timeFormatMD } from "@/utils";
import Swiper from "@c/Swiper";
import { mapMutations } from "vuex";

export default {
  filters: {
    timeFormatDate,
    timeFormatYear,
    timeFormatMD
  },
  data() {
    return {
      typeData: [
        {
          icon: "type-tel",
          img: require("@a/img/type-tel.png"),
          text: this.$t("professionalServices"),
          tips: this.$t("professionalServicesText")
        },
        {
          icon: "type-pc",
          img: require("@a/img/type-pc.png"),
          text: this.$t("strongTechnicalAbility"),
          tips: this.$t("strongTechnicalAbilityText")
        },
        {
          icon: "type-service",
          img: require("@a/img/type-service.png"),
          text: this.$t("focusOnCustomerServices"),
          tips: this.$t("focusOnCustomerServicesText")
        },
        {
          icon: "type-cc",
          img: require("@a/img/type-cc.png"),
          text: this.$t("worryfreeMaintenanceOfIterativeWarranty"),
          tips: this.$t("worryfreeMaintenanceOfIterativeWarrantyText")
        }
      ],
      indexData: undefined,
      newsListCatData: [],
      swiperImgs: []
    };
  },
  components: {
    Swiper
  },
  created() {
    this.topingAll();
    this.productCat();
    this.newsListCat();
  },
  computed: {
    bannerImgs() {
      return this.swiperImgs.length
        ? this.swiperImgs.filter(v => Number(v.typelist) === 1)
        : [];
    },
    itemImgsA() {
      return this.swiperImgs.length
        ? this.swiperImgs.filter(v => Number(v.typelist) === 9)
        : [];
    },
    itemImgsB() {
      return this.swiperImgs.length
        ? this.swiperImgs.filter(v => Number(v.typelist) === 10)
        : [];
    },
    itemImgsC() {
      return this.swiperImgs.length
        ? this.swiperImgs.filter(v => Number(v.typelist) === 11)
        : [];
    },
    itemImgsD() {
      return this.swiperImgs.length
        ? this.swiperImgs.filter(v => Number(v.typelist) === 12)
        : [];
    }
  },
  methods: {
    ...mapMutations(["PRODUCT_DATA"]),
    topingAll(params) {
      API.topingAll(params).then(res => {
        if (/^(1)$/.test(res.code)) {
          this.$set(this, "swiperImgs", res.data);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    productCat(params) {
      API.productCat(params).then(res => {
        if (/^(1)$/.test(res.code)) {
          this.PRODUCT_DATA(res.data);
          LStore.set("productData", res.data);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    index(params) {
      API.index(params).then(res => {
        if (/^(1)$/.test(res.code)) {
          this.$set(this, "indexData", res.data);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    newsListCat(params) {
      API.newsListCat(params).then(res => {
        if (/^(1)$/.test(res.code)) {
          this.$set(this, "newsListCatData", res.data.data);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    newsCasesCat(params) {
      API.newsCasesCat(params).then(res => {
        if (/^(1)$/.test(res.code)) {
          this.$message({
            message: res.msg,
            type: "success",
            duration: 1000,
            onClose: () => {}
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    onRouter(v) {
      this.$router.push({
        path: "list",
        query: {
          id: v.id,
          casescatId: v.casescat_id
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.tab-title {
  font-size: 14px;
  color: var(--color-black);
  font-weight: bold;
  margin: 40px 0;
}

.tab-wrap {
  .tab-menu-wrap {
    font-size: 14px;
    color: var(--color-black);

    .tab-menu {
      height: 60px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid rgba(97, 97, 97, 0.4);
      cursor: pointer;

      span {
        padding: 0 10px;
      }

      &.active,
      &:hover {
        background: var(--color-green);
        color: var(--color-white);
      }
    }
  }
}

.info-section {
  background: var(--color-grey);
  padding-bottom: 20px;

  .product-wrap {
    height: 400px;
    margin: 95px 0 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--color-white);

    .product-img {
      width: 200px;
    }
  }

  .title-box {
    font-size: 24px;
    color: var(--color-black);
    font-weight: bold;
    margin: 95px 0 40px;
  }
  .line-h {
    width: 60px;
    height: 4px;
    margin: 30px 0;
    background: var(--color-black);
    border-radius: 5px;
  }
  .info-box {
    font-size: 14px;
    color: var(--color-light-black);
    line-height: 24px;
  }
}

.type-section {
  margin-bottom: 30px;
}
.type-head {
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    max-width: 100%;
  }

  .head-img {
    // width: 300px;
    font-size: 30px;
    font-weight: bold;
    text-align: center;
  }
}
.type-box {
  padding: 20px;
  background: var(--color-grey);

  .type-icon {
    width: 60px;
    height: 60px;
    margin: 30px auto 0;

    &.type-service {
      width: 70px;
    }
    img {
      max-width: 100%;
    }
  }

  .type-text {
    min-height: 60px;
    margin: 30px 0 0;
    font-size: 22px;
    font-weight: 600;
    color: var(--color-black);
    text-align: center;
  }

  .type-tips {
    line-height: initial;
    font-size: 14px;
    color: var(--color-bright-black);
  }
}

.index-news-title {
  height: 100px;
  display: flex;
  align-items: center;
  font-size: 22px;
  font-weight: 600;
  color: var(--color-black);
}

.index-news-wrap {
  padding-top: 40px;
  .news-item {
    position: relative;
    display: flex;
    margin-bottom: 20px;
    line-height: initial;
    cursor: pointer;
  }

  .date-box {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    min-width: 80px;
    padding: 10px;
    margin-right: 10px;
    text-align: center;
    background: var(--color-green);
    color: var(--color-white);

    .year {
      font-size: 20px;
      font-weight: bold;
    }
  }
}

@media only screen and (max-width: 767px) {
  .tab-title {
    margin: 20px 0;
  }
  .info-section {
    .product-wrap,
    .title-box {
      margin: 20px 0;
    }
  }
  .type-row {
    padding: 0 20px;

    .type-box {
      min-height: 210px;
      margin-bottom: 20px;

      .type-text {
        font-size: 16px;
      }
    }
  }

  .tab-wrap {
    .tab-menu-wrap {
      overflow-x: auto;
      list-style: none;
      white-space: nowrap;
      &::-webkit-scrollbar {
        display: none;
      }
      .tab-menu {
        display: inline-block;
        border: 0;
        height: 40px;
        line-height: 40px;
      }
    }
  }

  .index-news-title,
  .index-news-wrap {
    padding: 0 20px;
  }
}
</style>
